import { render } from "./RegisterAnime.vue?vue&type=template&id=40de73b1"
import script from "./RegisterAnime.vue?vue&type=script&lang=js"
export * from "./RegisterAnime.vue?vue&type=script&lang=js"

import "./RegisterAnime.vue?vue&type=style&index=0&id=40de73b1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__